import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SocketAdminService } from '@shared-angular/services/socketadmin.service';
import { ProjectKeyValEntry, QUIZ_HISTORY_TYPE, QuizAnswerLogEntry } from '@shared/ProjectKeyValStore';
import { ButtonModule } from "primeng/button";
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { Subscription } from 'rxjs';
import { ProjectSubmenuComponent } from 'src/app/project-submenu/project-submenu.component';
import { ProjectKeyvalAdminService } from 'src/app/shared/services/project-keyval-admin.service';
import { ProjectService } from 'src/app/shared/services/project.service';

@Component({
    imports: [DatePipe, TableModule, TagModule, ProjectSubmenuComponent, ButtonModule],
    templateUrl: './project-quiz-user.component.html'
})
export class ProjectQuizUserComponent implements OnInit, OnDestroy {
    public userId: string = '';
    public userName: string = '';
    public entries: QuizAnswerLogEntry[] = [];
    public readonly richtigLabel = $localize`:@@quiz-correct-label:Richtig`;
    public readonly falschLabel = $localize`:@@quiz-wrong-label:Falsch`;

    private subs: Subscription[] = [];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private adminService: ProjectKeyvalAdminService,
        private projectService: ProjectService,
        private socketService: SocketAdminService
    ) { }

    private get projectId(): string {
        return this.projectService.selectedProject?._id ?? '-';
    }

    public async ngOnInit() {
        this.userId = this.route.snapshot.params['userId'] as string;
        await this.loadData();

        this.subs.push(
            this.socketService.onProjectKeyValChange.subscribe(() => { void this.loadData(); }),
            this.socketService.onProjectKeyValClean.subscribe(() => { void this.loadData(); }),
            this.socketService.onProjectKeyValDelete.subscribe(() => { void this.loadData(); })
        );
    }

    public ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }

    private async loadData() {
        const [keyvals, users] = await Promise.all([
            this.adminService.getProjectKeyVals(this.projectId),
            this.adminService.getProjectKeyValUsers(this.projectId)
        ]);
        const user = users[this.userId];
        this.userName = user?.name ?? user?.guestId ?? this.userId;
        this.entries = keyvals
            .filter(kv => kv.type === QUIZ_HISTORY_TYPE && kv.userId === this.userId)
            .map((kv) => {
                try {
                    return JSON.parse(String((kv as ProjectKeyValEntry<string>).value)) as QuizAnswerLogEntry;
                } catch {
                    return null;
                }
            })
            .filter((e): e is QuizAnswerLogEntry => e != null)
            .sort((a, b) => b.answeredAt.localeCompare(a.answeredAt));
    }

    public back() {
        void this.router.navigate(['/bot-admin/project', this.projectId, 'quiz']);
    }
}
